











































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Utils } from "@/services/utils";
import Number from "@/shared/filters/Number";

import ComponentWithGroupShaten from "@/views/components/ComponentWithGroupShaten";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";
import { CommonService } from "@/services/Common.service";
import { CheckExpTablesService } from "@/services/CheckExpTables.service";

interface FormItem {
  groupCd: string;
  shatenCd: string;
}

@Component({
  filters: {
    Number
  },
  mixins: [FilterSelectBox]
})

export default class CheckExpTables extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;
  util: Utils = new Utils();
  checkExpTablesService: CheckExpTablesService = new CheckExpTablesService();

  loading = false;
  form: FormItem = {
    groupCd: "",
    shatenCd: "",
  };
  disableBtnSearch: boolean = true;

  showCheckExpTablesList: any[] =  [];

  private mounted() {
    this.form = {
      groupCd: "",
      shatenCd: ""
    };

    this.getGroupDataList().then(res => {
      this.getShatenDataList().then(res2 => {
      });
    });
  }

  async selectGroup1() {
    this.selectGroup();
  }

  clearFormData() {
    this.form.groupCd = "";
    this.form.shatenCd = "";
    this.showCheckExpTablesList = [];
  }

  public async onSearchData() {
    this.$set(this, "loading", true);
    this.showCheckExpTablesList = [];
    const response = await this.checkExpTablesService.getCheckExpTables(
      this.form
    );
    this.$set(this, "loading", false);
    if (response) {
      this.showCheckExpTablesList = response;
    }
  }

  isSuccess(param: any) {
    if (param.isRequired === 0) {
      return true;
    }
    if (param.expTableCnt <= param.sknTableCnt) {
      return true;
    }
    return false;
  }

}
